import { CalendarDays } from "lucide-react";
import React from "react";
import GradientBtn from "../WebsiteComponents/GradientBtn";
import PrintStatus from "../GlobalComponents/PrintStatus";
import { Skeleton } from "@mui/material";
import { CURRENCY } from "src/lib/constans";

interface StatusKeys {
  pending?: string;
  cancel?: string;
  complete?: string;
  delivered: string;
}

interface IProps {
  orderId?: string;
  status?: string;
  statusKeys?: StatusKeys;
  message?: string;
  date?: string;
  orderPrice?: number;
  totleProducts?: number;
  onViewDetails?: () => void;
  skeleton?: boolean;
  id?: string;
  read?: boolean;
}

const OrdersCard: React.FC<IProps> = ({
  id,
  orderId,
  status,
  statusKeys = {
    cancel: "cancelled",
    pending: "pending",
    complete: "completed",
    delivered: "delivered",
  },
  message,
  date,
  orderPrice,
  totleProducts,
  onViewDetails = () => {},
  skeleton = false,
  read = false,
}) => {
  return (
    <div
      className={`w-full p-2 flex flex-col gap-1 lg:gap-1.5 2xl:gap-2  border border-[#D5D5D5] rounded-md shadow-all-light ${
        !read ? "unread-highlight" : "bg-white"
      }`}
    >
      {skeleton ? (
        <>
          <div className="flex items-center justify-between">
            <Skeleton
              variant="text"
              className="w-1/5 h-7 sm:h-8"
              sx={{ width: "20%" }}
            />
            <Skeleton
              variant="rectangular"
              className="w-20 h-7 sm:h-8"
              sx={{ borderRadius: 1 }}
            />
          </div>
          <Skeleton variant="text" className="w-full h-7 sm:h-8" />
          <Skeleton variant="text" className="w-2/5 h-7 sm:h-8" />
          <div className="flex items-center justify-between">
            <Skeleton variant="rectangular" className="w-20 h-7 sm:h-8" />
            <Skeleton variant="text" className="w-1/3 h-7 sm:h-8" />
          </div>
          <Skeleton
            variant="rectangular"
            className="w-full h-8 sm:h-9 mt-2"
            sx={{ borderRadius: 8 }}
          />
        </>
      ) : (
        <>
          <div className="flex items-center justify-between">
            <p className="theme-color-green-3b font-size-16px font-Poppins-Regular">
              {orderId}
            </p>
            <PrintStatus status={status || ""} statusKeys={statusKeys as any} />
          </div>
          <p className="font-size-16px font-Poppins-Medium theme-color-green-20 line-clamp-2">
            {message || ""}
          </p>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-1">
              <CalendarDays size={16} color="#3E3E3E" />
              <p className="font-size-14px font-Poppins-Regular text-[#3E3E3E]">
                {date || "N/A"}
              </p>
            </div>
            <div className="flex items-center gap-1">
              <p className="font-size-14px font-Poppins-Regular text-[#3E3E3E]">
                Total Products ({totleProducts || "0"}) :
              </p>
              <p className="font-size-16px font-Poppins-Medium theme-color-green-20">
                {CURRENCY} {orderPrice}
              </p>
            </div>
          </div>
          <GradientBtn
            ButtonText="View Details"
            onPress={onViewDetails}
            id={id}
          />
        </>
      )}
    </div>
  );
};

export default OrdersCard;
